var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{key:"key",staticClass:"sugoroku-circle",style:(_vm.styles),on:{"click":_vm.click}},[_c('div',{key:"`${key}_c`",staticClass:"sugoroku-circle__current",style:(_vm.stylesCurrent)})])}
var staticRenderFns = []

export { render, staticRenderFns }